import React from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';

export interface LabeledValue {
  name: string;
  value: string;
}
export interface LabeledValuesProps {
  labeledValues: Array<LabeledValue>;
  darkMode?: boolean;
}

const LabeledValues = ({ labeledValues, darkMode }: LabeledValuesProps) => {
  return (
    <dl className="grid grid-cols-[repeat(2,auto)] order-2 gap-y-2 gap-x-8 items-baseline justify-center justify-items-start text-left lg:flex lg:gap-0">
      {labeledValues?.map(({ name, value }) => {
        return (
          <React.Fragment key={`${name}-${value}`}>
            <dt
              className={classNames(
                'mb-0 tra-text-web-utl-label-l normal-case tracking-normal',
                darkMode ? 'text-warm-400' : 'text-neutral-500',
              )}
            >
              {name}
            </dt>
            <dd
              className={classNames(
                'lg:pl-4 lg:pr-10 lg:last-of-type:pr-0 mb-0',
                darkMode ? 'text-warm-100' : 'text-neutral-400',
              )}
            >
              {value}
            </dd>
          </React.Fragment>
        );
      })}
    </dl>
  );
};

export default LabeledValues;
